import { Stack, Typography } from '@mui/material';
import LoadingSkeleton from 'src/components/common/LoadingSkeleton';
import MainContainer from 'src/components/common/MainContainer';
import { VesselDetailBox } from 'src/features/VesselDetail/config';

const VesselDetailLoading = () => {
  return (
    <MainContainer>
      <Stack spacing={3}>
        <VesselDetailBox>
          <Stack spacing={2}>
            <LoadingSkeleton count={3} />
            <Stack spacing={2} direction={'row'}>
              <VesselDetailBox flexBasis={'50%'}>
                <LoadingSkeleton count={23} />
              </VesselDetailBox>
              <Stack spacing={2} flexBasis={'50%'}>
                <VesselDetailBox>
                  <LoadingSkeleton count={10} />
                </VesselDetailBox>
                <VesselDetailBox>
                  <LoadingSkeleton count={10} />
                </VesselDetailBox>
              </Stack>
            </Stack>
          </Stack>
        </VesselDetailBox>

        <Stack mt={2} direction={'row'} spacing={3}>
          <VesselDetailBox p={2} flex={1}>
            <Typography mb={2} variant="h6">
              Recent speed (km/h)
            </Typography>
            <LoadingSkeleton count={10} />
          </VesselDetailBox>
          <VesselDetailBox p={2} flex={1}>
            <Typography mb={2} variant="h6">
              Recent draught (m)
            </Typography>
            <LoadingSkeleton count={10} />
          </VesselDetailBox>
        </Stack>

        <VesselDetailBox>
          <Typography mb={3} variant="h6">
            Video
          </Typography>

          <LoadingSkeleton count={20} />
        </VesselDetailBox>
      </Stack>
    </MainContainer>
  );
};

export default VesselDetailLoading;
